module.exports = __webpack_public_path__ + "img/97.f927ae7e.jpg";